/** Release availability only. Onboarding, compliance and backend permissions
 * remain separate requirements; callers supply authenticated context facts. */
export function isClientConsoleAvailable({
    consoleAccessEnabled,
    isSelfClient,
    platformEligible
}: {
    consoleAccessEnabled: boolean;
    isSelfClient: boolean;
    platformEligible: boolean;
}): boolean {
    return platformEligible && (consoleAccessEnabled || isSelfClient);
}
